
import objectPath from 'object-path'
import initialStateExcursion from './initialState'
import { cart } from '@/utils/mapping'

const mutations = {
  clearExcursionsState(state) {
    state.excursions = []
  },
  setExcursionInitial(state) {
    state.excursions.push(initialStateExcursion())
  },
  setExcursions(state, { excursionIndex, searchId, results }) {
    state.excursions[excursionIndex].serviceLoaded = true

    const collection = results.map(item => cart.excursion(item))
    const { name, slug, prices } = collection[0]
    const current = {
      name,
      slug,
      price: prices[0].price,
      timeStart: prices[0].from
    }

    const excursion = {
      goType: state.excursions[excursionIndex].form.goType,
      type: state.excursions[excursionIndex].form.type,
      current,
      collection,
      prices,
      priceIndex: 0
    }

    state.excursions[excursionIndex].excursions.searchId = searchId
    state.excursions[excursionIndex].selected.push(excursion)

    this.commit('cart/updateTotalExcursionsCost', {
      excursionIndex
    })
  },
  deleteSelectedExcursion(state, { excursionIndex, index }) {
    state.excursions[excursionIndex].selected.splice(index, 1)
    state.allPenalties.excursions.splice(index, 1)

    this.commit('cart/updateTotalExcursionsCost', {
      excursionIndex
    })
  },
  updateTotalExcursionsCost(state, { excursionIndex }) {
    const price = state.excursions[excursionIndex].selected.reduce((sum, service) => ({
      amount: sum.amount + service.current.price.amount,
      markup: sum.markup + service.current.price.markup
    }), { amount: 0, markup: 0 })

    state.excursions[excursionIndex].excursions.current.price = {
      ...state.excursions[excursionIndex].excursions.current.price,
      ...price
    }
  },
  setExcursionsPenalties(state, { target, penalties }) {
    objectPath.set(state, `${target}.penalties`, {
      ...objectPath.get(state, `${target}.penalties`),
      isLoading: false,
      collection: penalties
    })
  },
  setExcursionDetailsLoading(state, { excursionIndex, status }) {
    state.excursions[excursionIndex].details.isLoading = status
  },
  setExcursionDetails(state, { excursionIndex, details }) {
    state.excursions[excursionIndex].details = {
      ...state.excursions[excursionIndex].details,
      ...details
    }
  },
  updateSelectedCurrent(state, { target, value }) {
    const excursionIndex = target.split('.')[1]
    const {
      name,
      prices,
      slug
    } = objectPath.get(state, target).collection.find(item => item.slug === value)

    const current = {
      name,
      slug,
      price: prices[0].price,
      timeStart: prices[0].from
    }

    objectPath.set(state, `${target}.current`, current)
    objectPath.set(state, `${target}.prices`, prices)
    objectPath.set(state, `${target}.priceIndex`, 0)

    this.commit('cart/updateTotalExcursionsCost', {
      excursionIndex
    })
  }
}

export default mutations